import cn from 'classnames';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';

import { CssUiComponent } from '@webapp/common/components/survey-custom';
import { setHtml } from '@webapp/common/lib/ui';

import { usePipingAnswersReplacer } from '../../machine/use-piping-answers-replacer';

export const TextSection: FC<
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
        text: string;
        className?: string;
        style?: CSSProperties;
    }
> = ({ className, style, text }) => {
    const pipingAnswersReplacer = usePipingAnswersReplacer();
    return (
        <div data-testid='bundle-text' className={cn(className, CssUiComponent.WYSIWYG)} style={style}>
            <div {...setHtml(pipingAnswersReplacer(text))} />
        </div>
    );
};
